import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPTermsDatasource } from './../../global/datasources/ap_terms_datasource';
import { APModel, IAPProgram } from './../../global/models/ap_model';

export type LoadProgramAndTermsDataCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadProgramAndTermsDataCommand',
    function loadProgramAndTermsDataCommand(
      $http: ng.IHttpService,
      log: any,
      defineCommandORM: IDefineCommand,
      ngAPTermsDatasource: IAPTermsDatasource,
      ngAPModel: APModel
    ) {
      return defineCommandORM('loadProgramAndTermsDataCommand', (deferred) => {
        $http
          .get(`/academicplan/student_program_and_terms/`)
          .then((response: any) => {
            ngAPTermsDatasource.write(response.data.term);
            const program = _4.first(response.data.program as unknown as IAPProgram[]);
            ngAPModel.write({
              program: {
                [program.id]: program
              }
            });
            deferred.resolve(response);
          })
          .catch((error: any) => {
            log.disable();
            deferred.reject(error);
            log.enable();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/commands/load_program_and_terms_data_command.ts